import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-back-to-root',
    templateUrl: './back-to-root.component.html',
    styleUrls: ['./back-to-root.component.scss']
})
export class BackToRootComponent {
    @Input() label = '';
}
